import { render, staticRenderFns } from "./appointmentResult.vue?vue&type=template&id=f07c65b2&scoped=true"
import script from "./appointmentResult.vue?vue&type=script&lang=js"
export * from "./appointmentResult.vue?vue&type=script&lang=js"
import style0 from "./appointmentResult.vue?vue&type=style&index=0&id=f07c65b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07c65b2",
  null
  
)

export default component.exports